import React from "react";
import ReactDOM from "react-dom/client"; // React 18
import { ThemeProvider } from "react-bootstrap";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AppContextProvider from "./Contexts/AppContext";
import "./Styles/base.scss";

// Criar root com React 18
const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

// Renderizar a app
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// Medir performance
reportWebVitals();
